export default {
  black: "#262626",
  white: "#FAFAFA",
  bgColor: ["white", "#FAF389", "#FAD234", "#FFBD38"],
};
